'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactMdl = require('react-mdl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = function Option(props) {
  var className = props.className;
  var onClick = props.onClick;
  var children = props.children;

  return _react2.default.createElement(
    _reactMdl.MenuItem,
    { className: className, onClick: onClick },
    children || ''
  );
};

Option.propTypes = {
  className: _react.PropTypes.string,
  value: _react.PropTypes.any,
  disabled: _react.PropTypes.bool,
  onClick: _react.PropTypes.func,
  children: _react.PropTypes.string
};

exports.default = Option;


//////////////////
// WEBPACK FOOTER
// ./~/react-mdl-selectfield/lib/Option/Option.js
// module id = 259
// module chunks = 0